<template>
    <v-container fill-height fluid grid-list-xl class="pt-0">
        <v-layout justify-center wrap>
            <v-flex md12>
                <material-card color="green" class="grid-card">
                    <v-flex slot="header" v-if="title">
                        <v-layout row>
                            <span
                                class="title font-weight-light mb-0"
                                style="align-self: center"
                                >{{ getTitle() }}</span
                            >
                            <v-spacer></v-spacer>
                            <span
                                class="title font-weight-light mb-0"
                                style="align-self: center"
                                v-html="getCustomTitleText()"
                            ></span>
                        </v-layout>
                    </v-flex>
                    <div v-if="showGrid">
                        <div v-if="dataSource.isLoading()">
                            {{ startLoading() }}
                        </div>
                        <div v-if="dataSource.isLoaded()">
                            {{ finishLoading() }}
                        </div>
                        <DxDataGrid
                            v-bind:class="{
                                'dxgrid-clickable': navigationPath,
                            }"
                            class="mt-3 dxgrid-custom"
                            :data-source="dataSource"
                            :allow-column-reordering="true"
                            :allow-column-resizing="true"
                            column-resizing-mode="nextColumn"
                            :column-min-width="50"
                            :on-row-click="onRowClick"
                            :on-cell-click="onCellClick"
                            :on-content-ready="onGridLoaded"
                            :column-auto-width="true"
                            :customize-export-data="customizeExportData"
                            @toolbar-preparing="onToolbarPreparing($event)"
                            :on-cell-prepared="onCellPrepared"
                            @initialized="saveGridInstance"
                            @selection-changed="onSelectionChanged"
                            :on-exporting="onExporting"
                            :on-exported="onExported"
                            :on-row-updating="onRowUpdating"
                            :on-row-removing="onRowRemoving"
                            ref="grid"
                        >
                            <DxLoadPanel :enabled="false"> </DxLoadPanel>
                            <DxExport
                                :enabled="true"
                                :allow-export-selected-data="true"
                                :file-name="title"
                            />
                            <DxPaging :page-size="20" />
                            <!-- <DxRemoteOperations
                                :paging="true"
                            ></DxRemoteOperations> -->
                            <DxRemoteOperations
                                :filtering="true"
                                :paging="true"
                                :sorting="true"
                                :summary="false"
                                :grouping="false"
                                :group-paging="true"
                            />
                            <DxPager
                                :show-page-size-selector="true"
                                :allowed-page-sizes="pageSizes"
                                :show-info="true"
                            />
                            <DxFilterRow :visible="true" />
                            <DxStateStoring
                                :enabled="true"
                                type="custom"
                                storage-key="accounts"
                                :customSave="saveGrid"
                                :customLoad="loadGrid"
                            />
                            <DxHeaderFilter
                                :visible="true"
                                ref="headerFilter"
                            />
                            <DxSearchPanel
                                :visible="true"
                                :width="240"
                                placeholder="Search..."
                            />
                            <DxScrolling :useNative="true"></DxScrolling>
                            <DxColumn
                                v-for="column in columns"
                                :data-field="column.field"
                                :caption="column.label"
                                :data-type="column.type"
                                :format="column.format"
                                :cell-template="column.template"
                                :visible="column.visible"
                                :filter-type.sync="column.filterType"
                                :filter-values.sync="column.filterValues"
                                :filter-value.sync="column.filterValue"
                                :width="column.width"
                                :selected-filter-operation.sync="
                                    column.selectedFilterOperation
                                "
                                :header-filter="column.headerFilter"
                                :alignment="column.alignment"
                                :cssClass="column.cssClass"
                                :sort-order="column.sortOrder"
                                :sort-index="column.sortIndex"
                                :calculate-filter-expression="
                                    calculateFilterExpression
                                "
                                ref="column"
                            />
                            <DxColumnChooser
                                :enabled="true"
                                :allow-search="true"
                                mode="dragAndDrop"
                            />
                            <DxEditing
                                v-if="allowEditing || allowDeleting"
                                :allow-updating="allowEditing"
                                :allow-deleting="allowDeleting"
                                mode="row"
                            />
                            <DxSelection
                                :mode="selectionEnabled ? 'multiple' : 'none'"
                                showCheckBoxesMode="always"
                            />
                            <!-- <DxFilterPanel :visible="true" /> -->
                            <DxSummary
                                v-if="summaryOptions && summaryOptions.enabled"
                            >
                                <DxTotalItem
                                    v-if="!summaryOptions.isNumber"
                                    v-for="column in summaryOptions.columns"
                                    :column="column"
                                    summaryType="sum"
                                    valueFormat="currency"
                                    displayFormat="{0}"
                                >
                                </DxTotalItem>
                                <DxTotalItem
                                    v-if="summaryOptions.isNumber"
                                    v-for="column in summaryOptions.columns"
                                    :column="column"
                                    summaryType="sum"
                                    displayFormat="{0}"
                                >
                                </DxTotalItem>
                            </DxSummary>
                            <DxMasterDetail
                                :enabled="
                                    expandedOptions && expandedOptions.enabled
                                "
                                template="detailTemplate"
                            />
                            <template #detailTemplate="{ data }">
                                <component
                                    class="expanded-row"
                                    v-if="expandedOptions"
                                    :is="getTemplateName(data.data)"
                                    :row="data.data"
                                    :columns="columns"
                                    :reloadGrid="reloadGrid"
                                />
                            </template>
                            <template #link-cell-template="{ data }">
                                <router-link
                                    v-if="showLink(data)"
                                    :to="{
                                        name: getColumnLink(data).link,
                                        params: {
                                            id: getColumnLink(data).id,
                                        },
                                    }"
                                    >{{ getColumnLink(data).text }}</router-link
                                >
                                <div v-else>
                                    {{ data.value }}
                                </div>
                            </template>
                            <template #link-action-cell-template="{ data }">
                                <div v-if="!showLink || showLink(data)">
                                    <a
                                        @click.stop="linkAction(data)"
                                        class=""
                                        >{{ data.value }}</a
                                    >
                                </div>
                                <div v-else>
                                    {{ data.value }}
                                </div>
                            </template>
                            <template #link-audio-cell-template="{ data }">
                                <audio
                                    v-if="data.value"
                                    style="height: 25px;"
                                    controls
                                    :src="data.value"
                                ></audio>
                            </template>
                            <template #utc-to-est-template="{ data }">
                                {{ toEstTime(data.value) }}
                            </template>
                            <template #reset-all-filters="{ data }">
                                <v-btn
                                    @click="resetAllFilters"
                                    dark
                                    class="mx-1"
                                    small
                                    color="default"
                                >
                                    Reset
                                </v-btn>
                            </template>
                            <template #reload="{ data }">
                                <v-btn
                                    @click="reloadGrid"
                                    dark
                                    class="mx-1"
                                    small
                                    color="default"
                                >
                                    Reload
                                </v-btn>
                            </template>
                            <template #action-button="{ data }">
                                <button
                                    class="dxgrid-action_buttons mx-1 "
                                    v-if="
                                        showActionButton(data.text, data.name)
                                    "
                                    @click="data.onItemClick()"
                                    :loading="data.loading"
                                    v-bind:class="{
                                        'action-loading': actionsProcessing.includes(
                                            data.name
                                        ),
                                    }"
                                >
                                    {{ data.getActionText() }}
                                    <!-- <template slot="loader">
                                    <span>
                                        <v-layout row class="pl-2 pr-3 my-1">
                                            <v-icon
                                                class="custom-loader pr-2"
                                                light
                                                >mdi-cached</v-icon
                                            >
                                            <div class="mt-1">
                                                {{ data.text }}
                                            </div>
                                        </v-layout>
                                    </span>
                                </template> -->
                                </button>
                            </template>
                            <template #action-select="{ data }">
                                <v-select
                                    hide-details
                                    class="mb-0"
                                    style="width: 160px; margin-top: 7px; border-bottom: black 1px solid"
                                    :items="data.options.items"
                                    :clearable="data.options.clearable"
                                    v-model="data.options.value"
                                    @change="data.onItemClick"
                                    :label="data.text"
                                ></v-select>
                                <!-- <v-layout row>
                                    <div
                                        class="mr-2 ml-3 mb-0 pb-0"
                                        v-if="data.text"
                                        style="font-size: 15px !important"
                                    >
                                        {{ data.text }}
                                    </div>
                                    <DxSelectBox
                                        :items="data.options.items"
                                        :value.sync="data.options.value"
                                        @onValueChanged="data.onItemClick"
                                    />
                                </v-layout> -->
                            </template>
                            <template #action-datepicker="{ data }">
                                <v-menu
                                    class=""
                                    v-model="data.datePickerMenu"
                                    :close-on-content-click="true"
                                    offset-y
                                    full-width
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            style="max-width: 120px;"
                                            hide-details
                                            class="mr-3"
                                            v-model="data.options.value"
                                            :value="data.options.value"
                                            label="Date"
                                            prepend-icon="mdi-calendar"
                                            readonly
                                            v-on="on"
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker
                                        v-model="data.options.value"
                                        @change="
                                            data.onItemClick(data.options.value)
                                        "
                                    ></v-date-picker>
                                </v-menu>
                            </template>
                            <template #action-text="{ data }">
                                <div v-html="data.getText()"></div>
                            </template>
                            <template #action-options-menu="{ data }">
                                <v-menu offset-y>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            color="success"
                                            small
                                            dark
                                            v-on="on"
                                        >
                                            {{ data.text }}
                                            <v-icon right dark
                                                >mdi-menu-down</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-tile
                                            v-for="(item, index) in data.options
                                                .items"
                                            :key="index"
                                            @click=""
                                        >
                                            <v-list-tile-title
                                                @click="data.onItemClick(item)"
                                                >{{ item.text }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </template>
                            <template #action-menu="{ data }">
                                <v-menu offset-y>
                                    <template v-slot:activator="{ on }">
                                        <v-btn
                                            color="success"
                                            small
                                            dark
                                            v-on="on"
                                            v-bind:class="{
                                                'action-loading': actionsProcessing.includes(
                                                    data.name
                                                ),
                                            }"
                                        >
                                            {{ data.text }}
                                            <v-icon right dark
                                                >mdi-menu-down</v-icon
                                            >
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-tile
                                            v-for="(item, index) in data.options
                                                .items"
                                            :key="index"
                                            @click=""
                                        >
                                            <v-list-tile-title
                                                @click="
                                                    data.onItemClick(item.value)
                                                "
                                                >{{ item.text }}
                                            </v-list-tile-title>
                                        </v-list-tile>
                                    </v-list>
                                </v-menu>
                            </template>
                            <template #filter-tags="{ data }">
                                <div>
                                    <v-chip
                                        v-for="filter in columns.filter(
                                            hasFilter
                                        )"
                                        @input="clearFilter(filter)"
                                        close
                                        ><div class="font-weight-medium">
                                            {{ getFilterLabel(filter.field) }}
                                        </div>
                                        : {{ getFilterValue(filter) }}</v-chip
                                    >
                                </div>
                            </template>
                            <template #icon="{ data }">
                                <v-icon
                                    class="px-0"
                                    dark
                                    :color="getIconColor(data)"
                                    >{{ getIcon(data) }}</v-icon
                                >
                            </template>
                        </DxDataGrid>
                    </div>
                </material-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import "devextreme/dist/css/dx.common.css";
import "devextreme/dist/css/dx.light.css";
import DxButton from "devextreme-vue/button";
import {
    DxDataGrid,
    DxColumn,
    DxHeaderFilter,
    DxSearchPanel,
    DxFilterRow,
    DxExport,
    DxEditing,
    DxPaging,
    DxRemoteOperations,
    DxPager,
    DxStateStoring,
    DxColumnChooser,
    DxLoadPanel,
    DxMasterDetail,
    DxScrolling,
    DxSelection,
    DxFilterPanel,
    DxSummary,
    DxTotalItem,
} from "devextreme-vue/data-grid";
import { formatCurrency, getDomain } from "../../utils/helpers.js";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import moment from "moment";
import { EdmLiteral } from "devextreme/data/odata/utils";
import DxSelectBox from "devextreme-vue/select-box";

const PRIMARY_API_DOMAIN = "https://wercbergerproductions-app-164903695581.us-east1.run.app";
const FALLBACK_API_DOMAIN = "https://wercberger-productions.azurewebsites.net";

export default {
    name: "dx-grid",
    props: {
        url: { type: String },
        name: { default: null, type: String },
        baseUrl: { type: String },
        title: { type: String },
        footerMessage: { type: String },
        headerMessage: { type: String },
        mapper: { default: null, type: [Function, String] },
        navigationPath: { default: null, type: String },
        navigationField: { default: null, type: String },
        hideActions: { default: false, type: Boolean },
        selectionEnabled: { default: false, type: Boolean },
        columns: {},
        exportColumns: {},
        actions: {},
        sortOptions: {},
        expandedOptions: {},
        summaryOptions: {},
        onRowClicked: { default: null, type: Function },
        onCellClicked: { default: null, type: Function },
        beforeSetupGrid: { default: null, type: Function },
        paginate: { default: false, type: Boolean },
        allowEditing: { default: false, type: Boolean },
        allowDeleting: { default: false, type: Boolean },
        onLoaded: { default: null, type: Function },
        getCustomTitle: { default: null, type: Function },
        updateRow: { default: null, type: Function },
        deleteRow: { default: null, type: Function },
    },
    components: {
        DxDataGrid,
        DxColumn,
        DxHeaderFilter,
        DxSearchPanel,
        DxFilterRow,
        DxExport,
        DxEditing,
        DxPaging,
        DxRemoteOperations,
        DxPager,
        DxStateStoring,
        DxColumnChooser,
        DxLoadPanel,
        DxFilterPanel,
        DxMasterDetail,
        DxScrolling,
        DxSelection,
        DxSummary,
        DxTotalItem,
        DxSelectBox,
    },
    data: () => ({
        pageSizes: [20, 100, 200],
        dataSource: {},
        dataSourceCopy: {},
        columnsCopy: [],
        grid: "",
        showGrid: false,
        activeBaseUrl: "",
        currentGridUrl: "",

        actionsProcessing: [],
        responsive: false,

        filterOperaters: new Map([
            ["startswith", "Starts With"],
            ["endswith", "Ends with"],
            ["notcontains", "Not Contains"],
            ["contains", "Contains"],
            ["<>", "Do not equal"],
            ["=", "Equals"],
            ["<", "Less than"],
            [">", "Greater than"],
            ["<=", "Less than or equal to"],
            [">=", "Greater than or equal to"],
            ["between", "Between"],
        ]),
        calculateFilterExpression(filterValue, selectedFilterOperation) {
            // let column = this;
            // if(column.type == 'date') {
            //     console.log(column);
            // }
            // return column.defaultCalculateFilterExpression.apply(
            //     this,
            //     arguments
            // );
            const filter = this.defaultCalculateFilterExpression(
                filterValue,
                selectedFilterOperation
            );
            if (this.dataType == "date" && filter) {
                if (Array.isArray(filter[0])) {
                    filter[0][2] = new EdmLiteral(filter[0][2].toISOString());
                    filter[2][2] = new EdmLiteral(filter[2][2].toISOString());
                } else if (filter[2]) {
                    filter[2] = new EdmLiteral(filter[2].toISOString());
                }
            }
            return filter;
        },
    }),
    mounted() {
        this.onResponsiveInverted();
        window.addEventListener("resize", this.onResponsiveInverted);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.onResponsiveInverted);
    },
    async created() {
        this.init();
    },
    methods: {
        async init() {
            if (this.beforeSetupGrid) {
                await this.beforeSetupGrid();
            }

            this.showGrid = true;

            this.setupGrid(this.url);
        },
        onResponsiveInverted() {
            if (window.innerWidth < 991) {
                this.responsive = true;
            } else {
                this.responsive = false;
            }
        },
        customizeText(cell) {
            console.log(cell);
            return cell.value;
        },
        getNormalizedDomain(domain) {
            if (!domain) return "";

            return domain.endsWith("/") ? domain.slice(0, -1) : domain;
        },
        shouldRetryWithFallback(error) {
            const status = error && error.httpStatus;

            return !status || status === 0 || (status >= 500 && status <= 599);
        },
        getFallbackBaseUrl(baseUrl) {
            const normalizedBase = this.getNormalizedDomain(baseUrl);
            const primaryDomain = this.getNormalizedDomain(PRIMARY_API_DOMAIN);
            const fallbackDomain = this.getNormalizedDomain(FALLBACK_API_DOMAIN);

            if (!normalizedBase.startsWith(primaryDomain)) {
                return null;
            }

            return normalizedBase.replace(primaryDomain, fallbackDomain);
        },
        getStoreErrorHandler(baseUrl, urlPath) {
            return (error) => {
                console.log(error);

                if (error.httpStatus == 401) {
                    window.location.href = "/login";
                    return;
                }

                if (!this.shouldRetryWithFallback(error)) {
                    return;
                }

                const fallbackBaseUrl = this.getFallbackBaseUrl(baseUrl);
                if (!fallbackBaseUrl) {
                    return;
                }

                if (
                    this.getNormalizedDomain(this.activeBaseUrl) ==
                    this.getNormalizedDomain(fallbackBaseUrl)
                ) {
                    return;
                }

                this.activeBaseUrl = fallbackBaseUrl;
                this.setDataSources(urlPath, fallbackBaseUrl);
                this.reloadGrid();
            };
        },
        createDataSource(urlPath, baseUrl) {
            return new DataSource({
                store: new ODataStore({
                    version: 4,
                    url: baseUrl + "/odata/" + urlPath,
                    beforeSend: (e) => {
                        e.timeout = 30000;
                    },
                    onLoaded: this.onResultsLoaded,
                    errorHandler: this.getStoreErrorHandler(baseUrl, urlPath),
                }),
            });
        },
        setDataSources(urlPath, baseUrl) {
            this.currentGridUrl = urlPath;
            this.dataSource = this.createDataSource(urlPath, baseUrl);
            this.dataSourceCopy = this.createDataSource(urlPath, baseUrl);
        },
        setupGrid(urlPath) {
            this.columnsCopy = JSON.parse(JSON.stringify(this.columns));

            const gridUrl = urlPath || this.url;
            this.activeBaseUrl = this.baseUrl ? this.baseUrl : getDomain();
            this.setDataSources(gridUrl, this.activeBaseUrl);
        },
        isLoading() {
            return (
                typeof this.dataSource.isLoading === "function" &&
                this.dataSource.isLoading()
            );
        },
        isLoaded() {
            return (
                typeof this.dataSource.isLoaded === "function" &&
                this.dataSource.isLoaded()
            );
        },
        async loadAll() {
            const response = await this.grid
                .getDataSource()
                .store()
                .load();

            // const url = this.url.split("?");

            // let state = localStorage.getItem(url[0]);

            // if (state) {
            //     state = JSON.parse(state);
            //     state.pageSize = 20;

            //     localStorage.setItem(url[0], JSON.stringify(state));
            // }

            return response;
        },
        getCustomTitleText() {
            if (this.getCustomTitle) {
                return this.getCustomTitle();
            }
        },
        getTemplateName(data) {
            if (this.expandedOptions && this.expandedOptions.enabled) {
                return this.expandedOptions.getTemplateName
                    ? this.expandedOptions.getTemplateName(data)
                    : this.expandedOptions.template;
            }
        },
        dateRangeFilter(column) {
            function formatDate(date) {
                return new Date(date).toISOString();
            }

            function handleBetween(column) {
                if (!Array.isArray(column.filterValue)) return "";

                const date = new Date(Date.parse(column.filterValue[0]));

                date.setHours(0, 0, 0, 0);

                const nextDay = new Date(Date.parse(column.filterValue[1]));

                nextDay.setHours(0, 0, 0, 0);

                return `((${column.field} ge ${date.toISOString()}) and (${
                    column.field
                } lt ${nextDay.toISOString()}))`;
            }

            if (!column.filterValue) return "";

            if (
                !column.selectedFilterOperation ||
                column.selectedFilterOperation == "="
            ) {
                const date = new Date(Date.parse(column.filterValue));

                date.setHours(0, 0, 0, 0);

                const nextDay = new Date(Date.parse(column.filterValue));

                nextDay.setHours(0, 0, 0, 0);

                nextDay.setDate(nextDay.getDate() + 1);

                return `((${column.field} ge ${date.toISOString()}) and (${
                    column.field
                } lt ${nextDay.toISOString()}))`;
            } else if (column.selectedFilterOperation == "between") {
                return handleBetween(column);
            } else {
                const date = new Date(Date.parse(column.filterValue));

                date.setHours(0, 0, 0, 0);

                const nextDay = new Date(Date.parse(column.filterValue));

                nextDay.setHours(0, 0, 0, 0);

                nextDay.setDate(nextDay.getDate() + 1);

                switch (column.selectedFilterOperation) {
                    case ">":
                        return `(${column.field} ge ${nextDay.toISOString()})`;
                    case ">=":
                        return `(${column.field} ge ${date.toISOString()})`;
                    case "<=":
                        return `(${column.field} lt ${nextDay.toISOString()})`;
                    case "<":
                        return `(${column.field} lt ${date.toISOString()})`;
                    case "<>":
                        return `((${
                            column.field
                        } lt ${date.toISOString()}) or (${
                            column.field
                        } ge ${nextDay.toISOString()}))`;
                }
            }
        },
        numberFilter(column) {
            if (column.filterValues && column.filterValues.length) {
                return `(${column.filterValues
                    .map((v) => `(${column.field} eq ${v})`)
                    .join(" or ")})`;
            }

            if (!column.filterValue) return "";

            if (
                !column.selectedFilterOperation ||
                column.selectedFilterOperation == "="
            ) {
                return `(${column.field} eq ${column.filterValue})`;
            } else {
                switch (column.selectedFilterOperation) {
                    case ">":
                        return `(${column.field} gt ${column.filterValue})`;
                    case ">=":
                        return `(${column.field} ge ${column.filterValue})`;
                    case "<=":
                        return `(${column.field} le ${column.filterValue})`;
                    case "<":
                        return `(${column.field} lt ${column.filterValue})`;
                    case "<>":
                        return `(${column.field} ne ${column.filterValue})`;
                    case "between":
                        return `((${column.field} ge ${
                            column.filterValue[0]
                        }) and (${column.field} lt ${column.filterValue[1]}))`;
                }
            }
        },
        parseFilter(filter) {
            const filters = [].concat.apply(
                [],
                this.columns
                    .map((column) => {
                        const name = column.field;
                        const value = column.filterValue;
                        const type = column.type;
                        const filterValues = column.filterValues || [];

                        if (
                            ["", undefined, null].includes(value) &&
                            !filterValues.length
                        )
                            return;

                        if (type == "date") {
                            return this.dateRangeFilter(column);
                        }

                        if (type == "number") {
                            return this.numberFilter(column);
                        }

                        if (type == "boolean") {
                            if (value == "true") {
                                return `${name} eq ${value}`;
                            }

                            return `(${name} eq ${value})`;
                        }

                        if (filterValues.length) {
                            return `(${filterValues
                                .map(
                                    (v) =>
                                        `(tolower(${name}) eq '${v.toLowerCase()}')`
                                )
                                .join(" or ")})`;
                        }

                        if (column.selectedFilterOperation) {
                            return `(${
                                column.selectedFilterOperation
                            }(tolower(${name}), '${value.toLowerCase()}'))`;
                        }

                        return `(contains(tolower(${name}), '${value.toLowerCase()}'))`;
                    })
                    .filter(Boolean)
            );

            return `${filters.join(" and ")}`;
        },
        getDataSourceURL() {
            const filter = this.grid.getCombinedFilter();

            const dataSource = this.grid.getDataSource();

            const parsedFilter = this.parseFilter(filter);

            let filterParams = parsedFilter ? "$filter=" + parsedFilter : "";

            let url = dataSource.store()._url;

            if (filterParams) {
                url =
                    url +
                    (url.includes("?")
                        ? "&" + filterParams
                        : "?" + filterParams);
            }

            return url;
        },
        async loadAllWithFilter() {
            const filter = this.grid.getCombinedFilter();

            const dataSource = this.grid.getDataSource();

            dataSource.filter(filter);

            dataSource.paginate(false);

            const response = await dataSource.load();

            const name = this.name ? this.name : this.url.split("?")[0];

            let state = localStorage.getItem(name);

            if (state) {
                state = JSON.parse(state);
                state.pageSize = 20;

                localStorage.setItem(url[0], JSON.stringify(state));
            }

            return response;
        },
        customizeColumns(columns) {
            // const iconColumn = this.columns.find(c => c.isIcon);
            // if (iconColumn) {
            //     const column = columns.find(c => c.dataField == iconColumn.field);
            //     const index = columns.indexOf(column);
            //     columns[index].visibleIndex = 1;
            // }
        },
        calculte(v) {
            console.log(v);

            return 50;
        },
        getColumnLink(data) {
            const column = this.columns
                .filter((c) => !c.isIcon)
                .find((c) => c.field == data.column.dataField);

            return {
                link: column.link,
                id: data.value ? data.value.trim() : data.value,
                text: data.text,
            };
        },
        getIconColor(data) {
            const column = this.columns.find(
                (c) => c.field == data.column.dataField
            );

            return column.iconColor(data.value, data.data);
        },
        getIcon(data) {
            const column = this.columns.find(
                (c) => c.field == data.column.dataField
            );

            return column.icon(data.value, data.data);
        },
        async onRowRemoving(data) {
            data.cancel = true;

            if (this.deleteRow) await this.deleteRow(data.data);

            data.component.cancelEditData();

            this.reloadGrid();
        },
        async onRowUpdating(data) {
            if (!this.updateRow) return;

            data.cancel = true;

            await this.updateRow(data);

            data.component.cancelEditData();

            this.reloadGrid();
        },
        showLink(data) {
            const column = this.columns
                .filter((c) => !c.isIcon)
                .find((c) => c.field == data.column.dataField);

            if (!column.showLink) return true;

            return column.showLink(data.data);
        },
        linkAction(data) {
            const column = this.columns
                .filter((c) => !c.isIcon)
                .find((c) => c.field == data.column.dataField);

            return column.linkAction(data.data);
        },
        getTitle() {
            if (
                !this.dataSource ||
                typeof this.dataSource.totalCount !== "function"
            )
                return this.title;

            const count =
                this.dataSource.totalCount() > 0
                    ? this.dataSource.totalCount()
                    : 0;

            return `${this.title} (${count})`;
        },
        onCellClick(event) {
            if (this.onCellClicked) {
                this.onCellClicked(event);

                return;
            }
        },
        onRowClick(event) {
            if (
                !this.navigationPath ||
                event.handled ||
                event.rowType == "detail" ||
                this.onCellClicked
            )
                return;

            if (this.onRowClicked) {
                this.onRowClicked(event.data, event);

                return;
            }

            this.$router.push({
                name: this.navigationPath,
                params: { id: event.data[this.navigationField] },
            });
        },
        startLoading() {
            this.$Progress.start();
        },
        finishLoading() {
            this.$Progress.finish();
        },
        saveGridInstance(e) {
            this.grid = e.component;
        },
        saveGrid(state) {
            const name = this.name ? this.name : this.url.split("?")[0];

            localStorage.setItem(name, JSON.stringify(state));
        },
        parseDateFilter(value, column) {
            if (!value) return value;

            if (column.type != "date") return value;

            return column.selectedFilterOperation == "between"
                ? value.map((v) => new Date(v))
                : new Date(value);
        },
        // isUsingDefaultFilters() {
        //     function getValues(value, column) {
        //         if (column.type == "date") {
        //             return Array.isArray(value)
        //                 ? value.map(v => new Date(v))
        //                 : new Date(value);
        //         }

        //         if (value && !value.length) return undefined;

        //         return value;
        //     }

        //     function getValue(value, column) {
        //         if (column.type == "date") {
        //             return Array.isArray(value)
        //                 ? value.map(v => new Date(v))
        //                 : new Date(value);
        //         }

        //         return value;
        //     }

        //     return this.columns.every(column => {
        //         const columnCopy = this.columnsCopy
        //             .filter(c => !c.isIcon)
        //             .find(c => c.field == column.field);

        //         if (
        //             getValue(column.filterValue, column) !=
        //                 getValue(columnCopy.filterValue, column) ||
        //             getValues(column.filterValues, column) !=
        //                 getValues(columnCopy.filterValues, column) ||
        //             column.selectedFilterOperation !=
        //                 columnCopy.selectedFilterOperation
        //         ) {
        //             console.log(columnCopy.field);
        //         }
        //         return (
        //             getValue(column.filterValue, column) ==
        //                 getValue(columnCopy.filterValue, column) &&
        //             getValues(column.filterValues, column) ==
        //                 getValues(columnCopy.filterValues, column) &&
        //             column.selectedFilterOperation ==
        //                 columnCopy.selectedFilterOperation
        //         );
        //     });
        // },
        loadGrid() {
            const name = this.name ? this.name : this.url.split("?")[0];

            let state = localStorage.getItem(name);
            if (state) {
                state = JSON.parse(state);
                state.columns.forEach((filter) => {
                    const column = this.columns
                        .filter((c) => !c.isIcon)
                        .find((c) => c.field == filter.dataField);
                    if (!column) return;

                    column.selectedFilterOperation = this.hasValue(
                        filter.selectedFilterOperation
                    )
                        ? filter.selectedFilterOperation
                        : column.selectedFilterOperation;
                    filter.selectedFilterOperation =
                        column.selectedFilterOperation;

                    column.filterValue = this.hasValue(filter.filterValue)
                        ? this.parseDateFilter(filter.filterValue, column)
                        : this.parseDateFilter(column.filterValue, column);
                    filter.filterValue = this.parseDateFilter(
                        column.filterValue,
                        column
                    );

                    column.filterValues = this.hasValue(filter.filterValues)
                        ? filter.filterValues
                        : column.filterValues;
                    filter.filterValues = column.filterValues;
                });

                this.handleIconColumn(state);
            }
            return state;
        },
        handleIconColumn(state) {
            const iconColumn = this.columns.find((c) => c.isIcon);

            if (!iconColumn) return;

            const stateIconColumn = state.columns.find(
                (s) => s.dataField == iconColumn.field
            );

            if (!stateIconColumn) return;

            const firstColumn = state.columns.find((c) => c.visibleIndex == 0);

            firstColumn.visibleIndex = 1;
            stateIconColumn.visibleIndex = 0;
        },
        clearFilter(filter) {
            const columns = this.columns.filter((c) => c.field == filter.field);

            columns.forEach((column) => {
                column.filterValue = null;
                column.filterValues = [];
                column.selectedFilterOperation = null;
            });
        },
        resetAllFilters(filter) {
            const url = this.name ? this.name : this.url.split("?")[0];

            localStorage.removeItem(url);

            location.reload();
            //this.init();
            // this.grid.clearFilter();

            // this.columns
            //     .filter((c) => !c.isIcon)
            //     .forEach((c) => (c.selectedFilterOperation = null));

            // this.resetDefaultFilters();
        },
        resetDefaultFilters() {
            this.columns.forEach((column) => {
                const columnCopy = this.columnsCopy
                    .filter((c) => !c.isIcon)
                    .find((c) => c.field == column.field);

                column.selectedFilterOperation =
                    columnCopy.selectedFilterOperation;
                this.grid.columnOption(
                    column.field,
                    "selectedFilterOperation",
                    column.selectedFilterOperation
                );
                column.filterValue = this.parseDateFilter(
                    columnCopy.filterValue,
                    columnCopy
                );
                this.grid.columnOption(
                    column.field,
                    "filterValue",
                    column.filterValue
                );
                column.filterValues = columnCopy.filterValues;
                this.grid.columnOption(
                    column.field,
                    "filterValues",
                    column.filterValues
                );
            });
        },
        hasFilter(column) {
            return (
                this.hasValue(column.filterValue) ||
                (column.filterValues && column.filterValues.length)
            );
        },
        hasValue(value) {
            if (value === false) return true;
            if (value === 0) return true;

            return value;
        },
        getFilterLabel(field) {
            const column = this.columns
                .filter((c) => !c.isIcon)
                .find((c) => c.field == field);

            return column ? column.label : field;
        },
        getFilterOperation(filter) {
            return filter.selectedFilterOperation
                ? (this.filterOperaters.get(filter.selectedFilterOperation) ||
                      filter.selectedFilterOperation) + ": "
                : "";
        },
        getFilterValue(filter) {
            const operation = this.getFilterOperation(filter);

            if (filter.type == "date") {
                if (filter.filterValues && filter.filterValues.length)
                    return (
                        "In: " +
                        filter.filterValues
                            .map((value) =>
                                value ? moment(new Date(value)).format("L") : ""
                            )
                            .join(", ")
                    );

                if (filter.selectedFilterOperation == "between") {
                    return (
                        operation +
                        filter.filterValue
                            .map((d) => moment(d).format("L"))
                            .join(" - ")
                    );
                }

                return operation + moment(filter.filterValue).format("L");
            }

            if (filter.filterValues && filter.filterValues.length)
                return "In: " + filter.filterValues.join(", ");

            return operation + filter.filterValue;
        },
        onToolbarPreparing(e) {
            const toolbarItems = [
                {
                    location: "before",
                    template: "filter-tags",
                },
                {
                    location: "after",
                    sortIndex: 0,
                    template: "reset-all-filters",
                },
                {
                    location: "after",
                    widget: "dxButton",
                    options: {
                        icon: "refresh",
                        onClick: this.reloadGrid,
                    },
                },
                // {
                //     location: "after",
                //     sortIndex: 1,
                //     template: "reload",
                // },
            ];

            if (this.actions) {
                let actionCount = 0;
                if (this.responsive) {
                    const buttonActions = this.actions.filter(
                        (a) =>
                            !a.isMenu &&
                            a.type != "select" &&
                            a.type != "datepicker" &&
                            a.type != "text"
                    );

                    toolbarItems.splice(actionCount + 1, 0, {
                        location: "after",
                        visible: true,
                        sortIndex: 1,
                        template: "action-options-menu",
                        text: "Options",
                        name: "Options",
                        onItemClick: (action) => {
                            this.runAction(action);
                        },
                        options: {
                            width: 200,
                            items: buttonActions,
                            displayExpr: "text",
                            valueExpr: "value",
                            value: "Options",
                        },
                    });
                }

                this.actions.forEach((action, index) => {
                    if (action.isMenu) {
                        toolbarItems.splice(actionCount + index + 1, 0, {
                            location: "after",
                            visible: true,
                            sortIndex: 1,
                            template: "action-menu",
                            text: action.text,
                            name: action.name ? action.name : action.text,
                            onItemClick: (option) => {
                                this.runMenuAction(action, option);
                            },
                            options: {
                                width: 200,
                                items: action.items,
                                displayExpr: "text",
                                valueExpr: "value",
                                value: action.value,
                            },
                        });
                    } else if (action.type == "select") {
                        toolbarItems.splice(index + 1, 0, {
                            location:
                                action.align == "left" ? "before" : "after",
                            visible: true,
                            sortIndex: 1,
                            template: "action-select",
                            text: action.text,
                            onItemClick: action.onSelected,
                            options: {
                                width: 200,
                                items: action.values,
                                clearable: action.clearable
                                    ? action.clearable
                                    : false,
                                displayExpr: "text",
                                valueExpr: "value",
                                value: action.value,
                            },
                        });
                    } else if (action.type == "datepicker") {
                        toolbarItems.splice(index + 1, 0, {
                            location:
                                action.align == "left" ? "before" : "after",
                            visible: true,
                            sortIndex: 1,
                            template: "action-datepicker",
                            datePickerMenu: false,
                            text: action.text,
                            onItemClick: action.onChanged,
                            options: {
                                width: 200,
                                items: action.values,
                                displayExpr: "text",
                                valueExpr: "value",
                                value: action.value,
                            },
                        });
                    } else if (action.type == "text") {
                        toolbarItems.splice(index + 1, 0, {
                            location:
                                action.align == "left" ? "before" : "after",
                            visible: true,
                            sortIndex: 2,
                            template: "action-text",
                            text: action.text,
                            getText() {
                                return action.getText();
                            },
                        });
                    } else {
                        if (this.responsive) return;

                        toolbarItems.splice(index + 1, 0, {
                            onItemClick: () => {
                                this.runAction(action);
                            },
                            loading: action.loading ? action.loading : false,
                            location: "after",
                            text: action.text,
                            getActionText() {
                                return action.text;
                            },
                            visible: true,
                            sortIndex: 1,
                            name: action.name ? action.name : action.text,
                            template: "action-button",
                        });
                    }
                });
            }

            e.toolbarOptions.items.unshift(...toolbarItems);
        },
        onCellPrepared(e) {
            // if (e.rowType == "data") {
            //     e.cellElement.className += "strikeout-red";
            // }
        },
        showActionButton(actionText, name) {
            const action = this.actions.find(
                (a) => a.text == actionText || a.name == name
            );

            return action.showOnSelection
                ? this.grid.getSelectedRowKeys().length
                : true;
        },
        onSelectionChanged(e) {},
        customizeExportData(columns, rows) {
            rows.forEach(function(row) {
                let rowValues = row.values;
                for (let i = 0; i < rowValues.length; i++) {
                    if (rowValues[i] == "") rowValues[i] = "";
                    if (
                        /[^\x20-\x7F]/.test(rowValues[i]) &&
                        !/[\u0590-\u05FF]/.test(rowValues[i])
                    ) {
                        rowValues[i] = "";
                    }
                }
            });
        },
        onExporting(e) {
            this.columns
                .filter((c) => c.shouldAlwaysExport)
                .forEach((exportColumn) => {
                    e.component.beginUpdate();
                    e.component.columnOption(
                        exportColumn.dataField,
                        "visible",
                        true
                    );
                });

            const column = this.columns.find((c) => c.isIcon);

            if (!column) return;

            e.component.beginUpdate();
            e.component.columnOption(column.field, "visible", false);
        },
        onExported(e) {
            this.columns
                .filter((c) => c.shouldAlwaysExport)
                .forEach((exportColumn) => {
                    e.component.columnOption(
                        exportColumn.dataField,
                        "visible",
                        exportColumn.visible
                    );
                    e.component.endUpdate();
                });

            const column = this.columns.find((c) => c.isIcon);

            if (!column) return;

            e.component.columnOption(column.field, "visible", true);
            e.component.endUpdate();
        },
        reloadGrid() {
            if (this.grid) {
                this.grid.refresh();
            }
        },
        reloadDataSource(url) {
            const gridUrl = url || this.currentGridUrl || this.url;
            const baseUrl = this.activeBaseUrl
                ? this.activeBaseUrl
                : this.baseUrl
                  ? this.baseUrl
                  : getDomain();

            this.setDataSources(gridUrl, baseUrl);
        },
        getSelectedRowKeys() {
            return this.grid.getSelectedRowKeys();
        },
        getSelectedRowsData() {
            if (!this.grid) return;

            return this.grid.getSelectedRowsData();
        },
        onGridLoaded() {
            this.grid.clearSelection();
            this.grid.deselectAll();
        },
        toEstTime(date) {
            return moment(date)
                .subtract(4, "hours")
                .format("MM/DD/YYYY h:mm:ss A");
        },
        onResultsLoaded(result) {
            if (this.onLoaded) {
                this.onLoaded(result);
            }
        },
        async runMenuAction(action, option) {
            if (action.name) {
                this.actionsProcessing.push(action.name);
            }

            try {
                await action.action(option);
            } catch (e) {
                if (action.name) {
                    const index = this.actionsProcessing.indexOf(action.name);

                    this.actionsProcessing.splice(index, 1);
                }
            }

            if (action.name) {
                const index = this.actionsProcessing.indexOf(action.name);

                this.actionsProcessing.splice(index, 1);
            }
        },
        async runAction(action) {
            if (action.name) {
                this.actionsProcessing.push(action.name);
            }

            try {
                await action.action(this.grid.getSelectedRowKeys());
            } catch (e) {
                if (action.name) {
                    const index = this.actionsProcessing.indexOf(action.name);

                    this.actionsProcessing.splice(index, 1);
                }
            }

            if (action.name) {
                const index = this.actionsProcessing.indexOf(action.name);

                this.actionsProcessing.splice(index, 1);
            }
        },
    },
};
</script>
<style>
.dxgrid-custom tr:nth-child(even) {
    background-color: rgba(51, 68, 109, 0.03);
}

/*.strikeout-red {
    content: " " !important;
    position: absolute !important;
    top: 50% !important;
    left: 0 !important;
    color: red !important;
    background-color: red !important;
    border-bottom: 1px solid red !important;
    width: 100% !important;
}*/
.dxgrid-clickable tr {
    cursor: pointer;
}
.dxgrid-custom .dx-datagrid .dx-row > td {
    font-size: 16px;
    /*color: black;*/
    /*    text-align: left !important;*/
    padding: 0.75em 0.75em 0.75em 0.75em;
}
.dxgrid-custom .dx-datagrid .dx-column-lines > td {
    /*border-left: unset !important;
    border-right: unset !important;*/
}
.dxgrid-custom .dx-datagrid-focus-overlay {
    border: 2px solid #5cb860;
}
.dxgrid-custom .dx-datagrid-search-text {
    color: #fff;
    background-color: #5cb860;
}

.dxgrid-custom
    .dx-scrollable-customizable-scrollbars
    ::-webkit-scrollbar:horizontal {
    height: 14px !important;
    background: #f1f1f1 !important;
}

.dxgrid-custom
    .dx-scrollable-customizable-scrollbars
    .dx-scrollable-container::-webkit-scrollbar-thumb {
    background: rgba(0, 0, 0, 0.2);
}

.dxgrid-custom
    .dx-scrollable-customizable-scrollbars::-webkit-scrollbar-corner {
    background: #d2d2d2;
}

.reset-filter-button .dx-button-content {
    background-color: #999 !important;
    color: #fff !important;
    text-transform: uppercase !important;
}

.expanded-row td {
    padding: 0 !important;
    background-color: #fff !important;
}

.dxgrid-custom .dx-checkbox-checked .dx-checkbox-icon {
    color: #5cb860 !important;
}
.dxgrid-custom .dx-checkbox-indeterminate .dx-checkbox-icon {
    color: #5cb860 !important;
}

.dxgrid-custom .dx-checkbox-checked .dx-checkbox-icon {
    color: #5cb860 !important;
}

/*.dxgrid-action_buttons .v-btn.v-btn--icon {
    width: 41px;
    height: 30px !important;
    line-height: 30px !important;
}*/

.dxgrid-action_buttons {
    margin: 10px 1px;
    font-weight: 400 !important;
    height: auto;
    line-height: 1.5em;
    cursor: pointer;
    border-radius: 3px;
    box-shadow: 0 2px 2px 0 rgba(76, 175, 80, 0.14),
        0 3px 1px -2px rgba(76, 175, 80, 0.2),
        0 1px 5px 0 rgba(76, 175, 80, 0.12) !important;
    text-transform: uppercase;
    padding: 0.40625rem 1.25rem !important;
    font-size: 11px;
    color: #fff;
    background-color: #5cb860 !important;
}

.v-btn--loader.v-btn__content {
    display: none;
}

.custom-loader {
    animation: loader 1s infinite;
}
@-moz-keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
@-webkit-keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
@-o-keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}
@keyframes loader {
    from {
        transform: rotate(0);
    }
    to {
        transform: rotate(360deg);
    }
}

.action-loading {
    background: #dddddd !important;
    color: black !important;
    border: none !important;
    pointer-events: none !important;
    cursor: none !important;
}
</style>
